import * as moment from 'moment/moment';

export class CookieConfig {
  public static getExpireDate() {
    return moment().add(6, 'month').toDate();
  }
}
